import React from "react";
import snapQr from "../img/SnapQR.png";

export default function Snap() {
	return (
		<div className="SnapQr">
			<h1>Snapchat</h1>
			<img src={snapQr} alt="Snap Qr" />
		</div>
	);
}
